export default {
	section_main_banner: {
		title: {
			one: '힘을 실어주는',
			two: '당신의',
			three: '거래',
			four: '를',
			five: '암호화폐',
			six: '자산',
		},
		description: {
			one: '당사 플랫폼에서는 결제를 즉시 원활하게 수행할 수 있습니다,',
			two: '암호화폐 자산을 교환할 필요 없이 - 속도,',
			three: '보안 및 편의성을 보장합니다.',
		},
		cta_buttons: {
			one: '시작하기',
			two: '앱 다운로드',
		},
	},
	section_safety_speed: {
		cards: {
			secure_payment: {
				title: '안전한 결제',
				description:
					'JPWorldPay는 QR 코드 거래 중 귀하의 정보를 공개하지 않습니다.',
			},
			any_company: {
				title: '모든 회사',
				description:
					'24시간 언제 어디서나 오프라인 가맹점에서 즉시 안전하게 결제할 수 있습니다.',
			},
			touch_free: {
				title: '터치 프리',
				description:
					'현금이나 신용카드를 걱정하지 마세요 - 앱을 열고 결제하세요.',
			},
		},
		fastest_payment: {
			label: '최고 속도의 결제 시스템',
			title: {
				one: 'JPWorldPay의',
				two: '안전성',
				three: '과',
				four: '속도',
				five: '동시 실현',
			},
			description:
				'블록체인 기술의 입증된 안정성과 JPWorldPay의 고유한 플랫폼 혁신을 결합한 가장 빠르고 신뢰할 수 있는 결제 시스템을 경험하세요. 전례 없는 속도, 보안, 원활한 거래를 제공합니다.',
		},
		registration: {
			title: '무료 등록',
			description: '이메일 주소와 비즈니스에 대한 기본 정보만 있으면 됩니다.',
		},
		start_payment: {
			title: '결제 시작',
			description:
				'이메일과 회사명을 확인하고 계정을 연결하면 첫 판매 준비가 완료됩니다.',
		},
		cta_button: '등록 시작하기',
	},
	section_we_offer: {
		title: {
			one: '어디서나 쇼핑 즐기기',
			two: '무료로',
			three: '제공합니다',
		},
		description:
			'JPWorldPay는 최고의 기술, 최고의 서비스, 최고의 플랫폼을 완전히 무료로 제공합니다. 프리미엄 가격 없이 프리미엄 기능을 경험하세요. 초기 비용 없이 비즈니스를 성장시키세요. 원활하고 안전한 결제의 미래에 지금 동참하세요.',
		enjoy_shopping: {
			title: '어디서나 쇼핑 즐기기',
			description: 'JPWorldPay 지갑에 저장된 암호화폐로',
			boxes: {
				one: {
					title: '이상적인 암호화폐 지갑',
					description: {
						one: 'JPWorldPay에서 원하는',
						two: '암호화폐 지갑을 만드세요.',
					},
				},
				two: {
					title: '더 스마트하게 쇼핑하기',
					description: {
						one: '쇼핑할 때',
						two: 'JPWorldPay를 선택하세요.',
					},
				},
				three: {
					title: '저희와 함께 결제하기',
					description: {
						one: 'JPWorldPay에서 원하는',
						two: '암호화폐로 결제하세요.',
					},
				},
			},
			cta_button: '무료 계정 만들기',
		},
	},
	section_payment_free: {
		desktop: {
			label: '가장 빠른 결제 시스템',
			title: {
				one: '세계 어디서나',
				two: '사용',
				three: '가능합니다',
			},
			descriptionFirst:
				'JPWorldPay는 신용카드 없이도 원활하고 유연한 결제 경험을 제공합니다. 온라인 쇼핑이든 매장 내 쇼핑이든, Wi-Fi 연결만 있으면 간단한 QR 코드로 즉시 결제가 가능합니다.',
			descriptionSecond:
				'JPWorldPay는 키오스크와 POS 기기를 통한 오프라인 결제도 지원하여 언제 어디서나 거래를 완료할 수 있습니다 — 카드 없이, 번거로움 없이, 빠르고 안전한 결제만 있을 뿐입니다.',
			cta_button: '무료로 시작하기',
		},
		mobile: {
			label: '어디서나 쇼핑 즐기기',
			title: {
				one: '비즈니스 회원은',
				two: '무료',
			},
			description:
				'JPWorldPay는 신용카드 없이 작동합니다. Wi-Fi에 연결하기만 하면 QR 코드로 즉시 결제 가능 - 키오스크와 POS 기기를 통한 오프라인 결제도 가능합니다.',
			cta_button: '비즈니스 스토어 개설하기',
		},
	},
	section_business_anywhere: {
		label: '어디서나 쇼핑 즐기기',
		title: {
			one: '무료',
			two: '비즈니스 회원 대상',
		},
		description:
			'JPWorldPay는 신용카드 없이 작동합니다. Wi-Fi에 연결하기만 하면 QR 코드로 즉시 결제 가능 - 키오스크와 POS 기기를 통한 오프라인 결제도 가능합니다.',
		cta_button: '비즈니스 스토어 개설하기',
		advantage: {
			label: '가장 빠른 결제 시스템',
			title: {
				one: 'JPWorldPay와',
				two: '함께하면',
				three: '많은',
				four: '장점이',
				five: '있습니다',
			},
			description:
				'JPWorldPay는 신용카드 없이 작동합니다. Wi-Fi에 연결하기만 하면 QR 코드로 즉시 결제가 가능하며, 키오스크와 POS 기기를 통한 오프라인 결제도 가능합니다.',
			payment_methods: {
				qr_code: {
					title: 'QR 코드 결제',
					description: 'QR 코드로 쉽게 결제하기',
				},
				onetether: {
					title: 'JPWorldPay 결제',
					description: '어디서나 결제 가능',
				},
				kiosk: {
					title: '키오스크 & POS 기기',
					description: '편리한 오프라인 결제',
				},
			},
			cta_button: '쇼핑 및 결제 방법',
		},
	},
	section_question: {
		label: '질문과 답변',
		title: {
			one: '귀하의 목소리를',
			two: '듣습니다',
		},
		description:
			'JPWorldPay는 귀하의 피드백을 소중히 여기고 이를 실천에 옮깁니다. 실제 사용자의 의견을 경청하고 이를 바탕으로 개선하여 우리의 서비스가 관련성을 유지하고 사용자 친화적이며 귀하의 요구사항에 맞춰 구축되도록 보장합니다.',
		cta_button: 'Q&A 시작하기',
	},
	section_growth: {
		stats: {
			total_customers: {
				value: '800k',
				label: '총 고객 수',
			},
			customer_satisfaction: {
				value: '99.90%',
				label: '고객 만족도',
			},
			money_managed: {
				value: '260b',
				label: '관리 자금',
			},
		},
	},
	section_testimonials: {
		subtitle: 'JPWorldPay에 대한 고객의 평가',
		title: {
			one: '1,405,28명 이상의',
			two: '행복한 고객이',
			three: '신뢰하는',
			four: '우리의 서비스',
		},
		testimonial_card: {
			description:
				'JPWorldPay는 제가 사용해본 최고의 결제 플랫폼입니다. 사용하기가 매우 쉽고 고객 서비스도 훌륭합니다.',
			author: {
				name: '존 도',
				role: 'CEO, JPWorldPay',
			},
		},
	},
	section_newsletter: {
		label: '뉴스레터 구독',
		title: {
			one: '구독하고',
			two: '최신 소식 받아보기',
		},
		description: {
			one: '구독하시면 JPWorldPay의 제안과 업데이트를 받아보실 수 있습니다.',
			two: 'JPWorldPay 솔루션이 귀하의 비즈니스를 성장시키는 방법을 알아보세요.',
		},
		form: {
			placeholder: '이메일 주소',
			button: '지금 구독하기',
		},
	},
};
